// Everything that differs between banks' copies of this admin app lives here
// (plus src/assets/Logo.png). Copy the app to another bank, then edit this file.

export const BANK_NAME = "ASANTE AKYEM RURAL BANK PLC";

// Short name shown in the header next to "users", e.g. "SCB.users"
export const BANK_SHORT_NAME = "AARB";

export const API_URL = "https://asakyemrbapis.cbxapps.com/";

// Used only when the server's branch list can't be loaded. The branch picker
// normally loads branches from the server (company locations + the branches
// existing users are in), so new branches appear without a code change.
export const BANK_BRANCHES = [
  "head office",
  "juansa",
  "konongo",
  "agogo",
  "ofoase",
  "odumasi",
  "ayeduase",
  "roman hill",
  "afful nkwanta",
  "juaso",
];
